import { Item } from "./orders.api";

export interface ItemModel {
    id: number;
    order_id: number;
    order_number: string;
    group_id: string;
    representative_id: string;
    customer_id: string;
    customer_code: string;
    branch_code: string;
    customer: CustomerModel;
    line_id: string;
    staff_name: string;
    type: string;
    status: string;
    sales_date: Date;
    total_amount: string;
    created_at: Date;
    updated_at: Date;
    order_items: OrderItemModel[];
}

export interface CustomerModel {
    mt_code: string;
    branch_code: string;
    company_out_name: string;
    company_in_name: string;
}

export interface OrderItemModel {
    id: number;
    item_id: number;
    product_code: string;
    product_name: string;
    origin_code: string;
    origin_name: string;
    shipper_code: string;
    shipper_name: string;
    grade: string;
    rank: string;
    order_unit: string;
    order_quantity: number;
    weight: string;
    package_type: string;
    quantity_per_package: number;
    proposed_price: string;
    line_total: string;
    notes: string;
    created_at: Date;
    updated_at: Date;
}

export const OrdersMap = (data: Item[] = []): ItemModel[] => {
    if (!Array.isArray(data)) return [];
    return data.map((item): ItemModel => ({
        id: item?.id ?? 0,
        order_id: item?.order_id ?? 0,
        order_number: item?.order_number ?? "",
        group_id: item?.group_id ?? "",
        representative_id: item?.representative_id ?? "",
        customer_id: item?.customer_id ?? "",
        customer_code: item?.customer_code ?? "",
        branch_code: item?.branch_code ?? "",
        customer: item?.customer ? {
            mt_code: item.customer.mt_code ?? "",
            branch_code: item.customer.branch_code ?? "",
            company_out_name: item.customer.company_out_name ?? "",
            company_in_name: item.customer.company_in_name ?? "",
        } : {
            mt_code: item?.customer_code ?? "",
            branch_code: item?.branch_code ?? "",
            company_out_name: item?.customer_code || "店舗未設定",
            company_in_name: "",
        },
        line_id: item?.line_id ?? "",
        staff_name: item?.staff_name ?? "",
        type: item?.type ?? "",
        status: item?.status ?? "",
        sales_date: item?.sales_date ?? new Date(),
        total_amount: item?.total_amount != null ? String(item.total_amount) : "0",
        created_at: item?.created_at ?? new Date(),
        updated_at: item?.updated_at ?? new Date(),
        order_items: (item?.order_items || []).map((orderItem) => ({
            id: orderItem?.id ?? 0,
            item_id: orderItem?.item_id ?? 0,
            product_code: orderItem?.product_code ?? "",
            product_name: orderItem?.product_name ?? "",
            origin_code: orderItem?.origin_code ?? "",
            origin_name: orderItem?.origin_name ?? "",
            shipper_code: orderItem?.shipper_code ?? "",
            shipper_name: orderItem?.shipper_name ?? "",
            grade: orderItem?.grade ?? "",
            rank: orderItem?.rank ?? "",
            order_unit: orderItem?.order_unit ?? "",
            order_quantity: orderItem?.order_quantity ?? 0,
            weight: orderItem?.weight ?? "",
            package_type: orderItem?.package_type ?? "",
            quantity_per_package: orderItem?.quantity_per_package ?? 0,
            proposed_price: orderItem?.proposed_price != null ? String(orderItem.proposed_price) : "0",
            line_total: orderItem?.line_total != null ? String(orderItem.line_total) : "0",
            notes: orderItem?.notes ?? "",
            created_at: orderItem?.created_at ?? new Date(),
            updated_at: orderItem?.updated_at ?? new Date(),
        })),
    }));
};

export const ordersMap = OrdersMap;
